export default __webpack_public_path__ + "static/media/DNo.38-1.b4322623.jpg";